var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFullHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.417,
    height: 17.214,
    viewBox: "0 0 18.417 17.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_1",
    "data-name": "\\uD569\\uCE58\\uAE30 1",
    d: "M14744.481-3808.837c-3.636-1.822-8.431-6.246-8.482-10.752v-.137a6.482,6.482,0,0,1,.048-.7c.241-1.929,1.874-4.2,3.921-4.517a4.964,4.964,0,0,1,.744-.056,4.6,4.6,0,0,1,4,2.136,4.607,4.607,0,0,1,4-2.136,4.916,4.916,0,0,1,.741.056c2.047.315,3.68,2.588,3.921,4.517a6.1,6.1,0,0,1,.048.774v.015c-.015,4.521-4.832,8.971-8.482,10.8a.534.534,0,0,1-.227.052A.533.533,0,0,1,14744.481-3808.837Z",
    transform: "translate(-14735.499 3825.499)",
    fill: "#ff5f00",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullHeart);
export default __webpack_public_path__ + "static/media/icon_full_heart.4fa0cfa4c5303f608cef2778eac4c1bd.svg";
export { ForwardRef as ReactComponent };